// Mock data for Triansh Arts website

export const artworks = [
  {
    id: 1,
    title: "Sailboat Serenity",
    category: "Sketches",
    image: "https://customer-assets.emergentagent.com/job_1a50b2a8-6e90-491e-ad84-b5769dd7737d/artifacts/jnyx6903_IMG_0294.jpeg",
    description: "Monochrome sailboat sketch with dramatic lighting",
    price: "₹599"
  },
  {
    id: 2,
    title: "Mystic Eyes",
    category: "Portraits",
    image: "https://customer-assets.emergentagent.com/job_1a50b2a8-6e90-491e-ad84-b5769dd7737d/artifacts/xm0x7zw8_IMG_0296.jpeg",
    description: "Vibrant eye art with bold colors",
    price: "₹699"
  },
  {
    id: 3,
    title: "Cherry Blossom Bird",
    category: "Wildlife",
    image: "https://customer-assets.emergentagent.com/job_1a50b2a8-6e90-491e-ad84-b5769dd7737d/artifacts/hcman0lk_IMG_0297.jpeg",
    description: "Delicate watercolor bird on cherry blossoms",
    price: "₹299"
  },
  {
    id: 4,
    title: "Lord Shiva",
    category: "Paintings",
    image: "https://customer-assets.emergentagent.com/job_1a50b2a8-6e90-491e-ad84-b5769dd7737d/artifacts/m2pbvyy4_IMG_0298.jpeg",
    description: "Divine blue Shiva portrait",
    price: "₹399"
  },
  {
    id: 5,
    title: "Mountain Valley",
    category: "Paintings",
    image: "https://customer-assets.emergentagent.com/job_triansh-arts/artifacts/58f2kc7y_32B0E48E-E43C-4F67-825D-56800CB764AF.jpeg",
    description: "Serene watercolor valley landscape with mountains",
    price: "₹299"
  },
  {
    id: 6,
    title: "Coconut Still Life",
    category: "Paintings",
    image: "https://customer-assets.emergentagent.com/job_triansh-arts/artifacts/lqslqtom_IMG_0601.jpeg",
    description: "Vibrant watercolor coconut with tropical charm",
    price: "₹399"
  },
  {
    id: 7,
    title: "Sati and Shiva",
    category: "Sketches",
    image: "https://customer-assets.emergentagent.com/job_triansh-arts/artifacts/g5aer6yt_IMG_0469.jpeg",
    description: "Divine couple in elegant sketch with golden hues",
    price: "₹250"
  }
];

export const categories = [
  { name: "All", color: "#d987ff" },
  { name: "Sketches", color: "#88a2ff" },
  { name: "Paintings", color: "#ff84e4" },
  { name: "Portraits", color: "#ffe03d" },
  { name: "Wildlife", color: "#78d692" }
];

export const brandInfo = {
  name: "Triansh Arts",
  artistName: "Triansh Joshi",
  tagline: "Where Creativity Meets Canvas",
  about: "An artist since childhood, now turning passion into a thriving business. Each piece is crafted with dedication and love for art.",
  instagram: "https://www.instagram.com/triansh_arts?igsh=MTVuMm9qczlhNTc4dQ%3D%3D&utm_source=qr",
  sisterInstagram: "https://www.instagram.com/sketchrally.co?igsh=Mmp3aWtxZ2dtZWdl&utm_source=qr",
  sisterWebsite: "https://sketchrallyco.oodo.com",
  email: "trianshartstudio@gmail.com",
  logo: "https://customer-assets.emergentagent.com/job_1a50b2a8-6e90-491e-ad84-b5769dd7737d/artifacts/na7lshm0_IMG_0299.jpeg"
};

export const pricingTiers = [
  {
    id: 1,
    name: "Sketch Art",
    price: "Starting at ₹299",
    features: [
      "Black & white sketches",
      "Portrait or landscape format",
      "High-quality paper",
      "Custom subjects available"
    ],
    color: "#88a2ff"
  },
  {
    id: 2,
    name: "Watercolor Paintings",
    price: "Starting at ₹599",
    features: [
      "Vibrant watercolor art",
      "Nature & wildlife themes",
      "Premium watercolor paper",
      "Personalized designs"
    ],
    color: "#78d692"
  },
  {
    id: 3,
    name: "Custom Portraits",
    price: "Starting at ₹799",
    features: [
      "Detailed portrait art",
      "Multiple color options",
      "Canvas or paper medium",
      "Perfect for gifts"
    ],
    color: "#ff84e4",
    popular: true
  }
];
